import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import IngredientService from "../../services/ingredient/IngredientService";

export const IngredientContext = createContext("IngredientContext");

const IngredientContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [ingredientTotalElements, setIngredientTotalElements] = useState(0);
    const [ingredientList, setIngredientList] = useState([]);

    const [units, setUnits] = useState([])
    const [unitsTotalElements, setUnitsTotalElements] = useState(0)

    const getAllIngredient = async params => {
        try {

            setLoading(true);

            const res = await IngredientService.getAllIngredient(params);
            setIngredientList(res.data.content);
            setIngredientTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }
    const getAllUnits = async params => {
        try {

            setLoading(true);

            const res = await IngredientService.getAllUnits(params);
            setUnits(res.data.content);
            setUnitsTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <IngredientContext.Provider
            value={{
                loading,
                ingredientTotalElements,
                ingredientList,
                getAllIngredient,
                getAllUnits,
                units,
                unitsTotalElements
            }}
        >
            {children}
        </IngredientContext.Provider>
    );
}

export default IngredientContextProvider;
